import { useFetcher } from '@/api/useFetcher.ts';
import { useQuery } from '@tanstack/react-query';
import { GetLostHoursEmployeeListResponse, Routes } from '@/api/types.ts';

export const useLostHoursEmployeesListQuery = () => {
  const fetchData = useFetcher();

  return useQuery<GetLostHoursEmployeeListResponse>({
    queryKey: [Routes.LostHoursEmployees],
    queryFn: () => fetchData(Routes.LostHoursEmployees),
  });
};
